import { render, staticRenderFns } from "./ChartConfigsSideBar.vue?vue&type=template&id=5082c06e&"
import script from "./ChartConfigsSideBar.vue?vue&type=script&lang=js&"
export * from "./ChartConfigsSideBar.vue?vue&type=script&lang=js&"
import style0 from "./ChartConfigsSideBar.vue?vue&type=style&index=0&id=5082c06e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports